"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoWirelessAccountCompleteStatus = void 0;
var React = require("react");
var NoWirelessAccountState_1 = require("./NoWirelessAccountState");
/** Platform UI Components */
var GridRow_1 = require("@idp/ui-components/components/containers/Grid/GridRow");
var GridColumn_1 = require("@idp/ui-components/components/containers/Grid/GridColumn");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { NoWirelessAccountCms } from './NoWirelessAccount.cms';
/** Stylesheets */
var utilityStyles = require("../../../styles/utilities.scss");
var appStyles = require("../../../styles/login-widget.scss");
var styles = require("./NoWirelessAccount.scss");
/** LOB Components */
var PageLevelHeading_1 = require("../../common/PageLevelHeading");
var PageLevelHeadingProps_1 = require("../../common/PageLevelHeading/PageLevelHeadingProps");
var CtaButtonGroup_1 = require("../../common/CtaButtonGroup");
var CtaButtonGroupProps_1 = require("../../common/CtaButtonGroup/CtaButtonGroupProps");
/** Api, Reporting, Mappers, Request, Response */
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var localdatastore_1 = require("../../../api/localdatastore");
var Events_1 = require("../../../api/Events");
var NoWirelessAccountCompleteStatus;
(function (NoWirelessAccountCompleteStatus) {
    NoWirelessAccountCompleteStatus[NoWirelessAccountCompleteStatus["CONTINUE"] = 0] = "CONTINUE";
    NoWirelessAccountCompleteStatus[NoWirelessAccountCompleteStatus["LOGIN_ANOTHER"] = 1] = "LOGIN_ANOTHER";
})(NoWirelessAccountCompleteStatus = exports.NoWirelessAccountCompleteStatus || (exports.NoWirelessAccountCompleteStatus = {}));
var NoWirelessAccount = /** @class */ (function (_super) {
    __extends(NoWirelessAccount, _super);
    // private NoWirelessAccountCmsData: NoWirelessAccountCms;
    function NoWirelessAccount(props) {
        var _this = _super.call(this, props) || this;
        console.info('AccountSelection - construtor', props);
        _this.state = new NoWirelessAccountState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.continueBtnEvents = _this.continueBtnEvents.bind(_this);
        _this.anotherUserIDClickEvent = _this.anotherUserIDClickEvent.bind(_this);
        return _this;
    }
    NoWirelessAccount.prototype.componentDidMount = function () {
        console.info('componentDidMount');
        this.events = new Events_1.default([NoWirelessAccount.noWirelessAccountCompleteEvent]);
        this.analyticsNoWirelessAccountPageLoad();
    };
    NoWirelessAccount.prototype.analyticsNoWirelessAccountPageLoad = function () {
        // this.reportingService.firePageLoadEvent('/login/authentication');
        var isPageLoadedAlready = this.stateManager.get(localdatastore_1.getNamespace('LOGINUI'), 'isNoWirelessAccountLoadedAlready');
        if (!isPageLoadedAlready || !isPageLoadedAlready.loaded) {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.NO_WLS_ACCOUNT_PAGE, ReportingService_1.PageName.NO_WLS_ACCOUNT_PAGE);
            this.stateManager.set('isNoWirelessAccountLoadedAlready', { loaded: true });
        }
    };
    NoWirelessAccount.prototype.continueBtnEvents = function () {
        console.log('Continue Event Clicked.');
        this.reportingService.fireLinkClickEvent('Continue', ReportingService_1.PageUrls.NO_WLS_ACCOUNT_PAGE);
        this.fireComplete(NoWirelessAccountCompleteStatus.CONTINUE);
    };
    NoWirelessAccount.prototype.anotherUserIDClickEvent = function () {
        console.log('SignIn with UserID Event Clicked.');
        this.reportingService.fireLinkClickEvent('Sign in with another user ID', ReportingService_1.PageUrls.NO_WLS_ACCOUNT_PAGE);
        this.fireComplete(NoWirelessAccountCompleteStatus.LOGIN_ANOTHER);
    };
    NoWirelessAccount.prototype.fireComplete = function (status) {
        var data = {
            status: status,
        };
        this.events.fireEvent(data, NoWirelessAccount.noWirelessAccountCompleteEvent);
    };
    NoWirelessAccount.prototype.render = function () {
        var loginNoWirelessAccountTestId = 'Login_No_Wireless_Account';
        // this.NoWirelessAccountCmsData = CMS.get(new NoWirelessAccountCms(), 'NoWirelessAccount').content;
        this.NoWirelessAccountCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        var haveAnotherIdText = '';
        switch (this.props.data.filter) {
            case 'wireless':
                haveAnotherIdText = this.NoWirelessAccountCmsData.noWirelessAccount.haveAnotherIdDescWireless
                    || 'placeholder wireless';
                break;
            case 'broadband':
                haveAnotherIdText = this.NoWirelessAccountCmsData.noWirelessAccount.haveAnotherIdBroadbandText
                    || 'placeholder broadband';
                break;
            case 'dtvnow':
                haveAnotherIdText = this.NoWirelessAccountCmsData.noWirelessAccount.haveAnotherIdDtvNowText
                    || 'placeholder dtvnow';
                break;
            default:
                // tslint:disable-next-line:max-line-length
                haveAnotherIdText = "We can't find a account for that user ID. Have an account associated with a different ID ? Try using that ID to sign in.";
        }
        return (React.createElement("div", { className: [styles.loginNoWirelessAccountWrapper].join(' ') },
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: { size: 12, className: 'no-pad', customOptions: '' } },
                    React.createElement("div", { className: [utilityStyles.formRow].join(' ') },
                        React.createElement(PageLevelHeading_1.default, { data: {
                                headingText: this.NoWirelessAccountCmsData.common.iconHeadingTitle,
                            }, options: {
                                type: PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_WITH_ICON,
                            }, testId: loginNoWirelessAccountTestId + '_Header' })))),
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: {
                        size: 7,
                        className: appStyles.innerPanelContainer + ' pad-none',
                        customOptions: '',
                    } },
                    React.createElement("div", { className: [
                            utilityStyles.marTXxs,
                            utilityStyles.padTXxxs,
                            styles.signedInWith,
                        ].join(' ') },
                        React.createElement("span", null,
                            this.NoWirelessAccountCmsData.noWirelessAccount.signedInWithText,
                            "\u00A0"),
                        React.createElement("span", null,
                            React.createElement("strong", null,
                                this.NoWirelessAccountCmsData.noWirelessAccount.signedInWithTextUserIdLabel,
                                "\u00A0",
                                this.props.data.loggedInAccount))),
                    React.createElement("div", { className: [utilityStyles.marTXs].join(' ') },
                        React.createElement("h2", null, this.NoWirelessAccountCmsData.noWirelessAccount.haveAnotherIdSecondaryTitle)),
                    React.createElement("div", { className: [
                            utilityStyles.marTXxs,
                            utilityStyles.padTXxxs,
                        ].join(' ') }, haveAnotherIdText),
                    React.createElement("div", { className: [
                            utilityStyles.marTMdLg,
                        ].join(' ') },
                        React.createElement(CtaButtonGroup_1.default, { data: {
                                primaryBtnText: this.NoWirelessAccountCmsData.common.buttonPrimaryContinueCTA,
                                primaryBtnTestId: 'No_Wireless_Account_Button_Continue',
                                secondaryBtnText: this.NoWirelessAccountCmsData.noWirelessAccount.buttonSecondaryCTA,
                                secondaryBtnTestId: 'No_Wireless_Account_Button_Another_UserID',
                            }, options: {
                                type: CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_LEFT,
                            }, primaryBtnEvents: {
                                onClick: this.continueBtnEvents,
                            }, secondaryBtnEvents: {
                                onClick: this.anotherUserIDClickEvent,
                            } }))))));
    };
    NoWirelessAccount.noWirelessAccountCompleteEvent = 'noWirelessAccountCompleteEvent';
    return NoWirelessAccount;
}(React.Component));
exports.default = NoWirelessAccount;
//# sourceMappingURL=NoWirelessAccount.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/NoWirelessAccount/NoWirelessAccount.js
// module id = 647
// module chunks = 8